//=====================================================
//　SUBMITボタン
//=====================================================

interface IFProps {
    title : string,
    onClick? : React.MouseEventHandler<HTMLButtonElement>
}

export function BtnSubmit(props:IFProps){
    return (
        <button className="btn btn-primary btn-next" onClick={props.onClick}>{props.title}</button>
    );
}